import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'
import Img from 'gatsby-image'
import { mobile, tablet, desktop } from '../utils/media'

export default ({ projects }) => {
  const renderProject = ({ node }) => (
    <Link
      key={node.frontmatter.path}
      to={node.frontmatter.path}
    >
      <ProjectWrapper>
        <ResponsiveImage
          sizes={node.frontmatter.thumb.childImageSharp.sizes}
        />
        <h2>{node.frontmatter.title}</h2>
      </ProjectWrapper>
    </Link>
  )

  return <Projects>{projects.map(renderProject)}</Projects>
}

const Projects = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  margin: 200px auto 0;
  padding: 100px 0;
  border-top: 1px solid white;

  ::before {
    content: "More Projects";
    position: absolute;
    top: 35px;
    width: 100%;
    display: block;
    color: white;
    font-size: 18px;
    text-align: center;
    text-transform: uppercase;
    letter-spacing: 4.5px;

  }
`

const ProjectWrapper = styled.section`
  position: relative;
  display: block;
  margin: 0 0 30px;
  width: 280px;
  height: 280px;
  overflow: hidden;

  ${mobile`
    width: 300px;
    height: 300px;
  `}

  ${tablet`
    width: 230px;
    height: 230px;
  `}

  ${desktop`
    width: 300px;
    height: 300px;
  `}

  :not(:last-child) {
    margin: 0 0 15px;
  }

  ::after {
    z-index: 50;
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    opacity: .6;
    background: black;

    ${desktop`
      opacity: 0;
    `}
  }

  :hover::after {
    opacity: .5;
  }

  :hover > h2 {
    opacity: 1;
  }

  > h2 {
    z-index: 100;
    cursor: pointer;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    font-size: 25px;
    font-weight: 400;
    line-height: 280px;
    text-align: center;
    margin: 0;
    opacity: 1;

    ${mobile`
      line-height: 300px;
    `}

    ${tablet`
      line-height: 230px;
    `}

    ${desktop`
      opacity: 0;
      line-height: 300px;
    `}
  }
`

const ResponsiveImage = styled(Img)`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
`



// WEBPACK FOOTER //
// ./src/components/more-projects.js